<script setup lang="ts">
import { DividerFormElement } from "~/api";

const props = defineProps<{ modelValue: DividerFormElement }>();
</script>

<template>
  <div
    :class="['DividerComponent', modelValue.properties.thickness + '-divider']"
  >
    <div
      v-if="modelValue.label"
      class="line"
      :class="{ 'show-line': modelValue.properties.displayLine }"
    ></div>
  </div>
</template>
<style lang="less">
.component-renderer {
  &.component-indent-level-0 {
    .DividerComponent {
      margin-right: -6px;
      margin-left: -14px;
    }
  }
  &.component-indent-level-1 {
    .DividerComponent {
      margin-right: -6px;
      margin-left: -20px;
    }
  }
  &.component-indent-level-2 {
    .DividerComponent {
      margin-right: 32px;
    }
  }
  &.component-indent-level-3 {
    .DividerComponent {
      margin-right: 48px;
    }
  }
  &.component-indent-level-4 {
    .DividerComponent {
      margin-right: 64px;
    }
  }
  &.component-indent-level-5 {
    .DividerComponent {
      margin-right: 80px;
    }
  }
}
.DividerComponent {
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.Thin-divider {
    height: 3px;
    .line {
      height: 1px;
      background-color: var(--el-text-color-primary);
    }
  }

  &.Medium-divider {
    height: 7px;
    .line {
      height: 3px;
      background-color: var(--el-text-color-primary);
    }
  }

  &.Thick-divider {
    height: 12px;
    .line {
      height: 6px;
      background-color: var(--el-text-color-primary);
    }
  }

  .line {
    display: none;

    &.show-line {
      display: block;
    }
  }
}
</style>
